import React from 'react';

import IndustryCard from './IndustryCard';

const IndustryList = ({ entries = [], Component = IndustryCard, ...props }) => (
  <React.Fragment>{entries.map(Component)}</React.Fragment>
);

export default IndustryList;
